/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscles: NonNullable<unknown> }} Quick_Workout_AvoidedInputs */

const en_us2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Left out today, still recovering: ${i?.muscles}`)
};

const pt_br2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fora hoje, ainda recuperando: ${i?.muscles}`)
};

const es_419_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fuera hoy, aún en recuperación: ${i?.muscles}`)
};

const pt_pt2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fora hoje, ainda a recuperar: ${i?.muscles}`)
};

const fr_fr2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Laissés de côté aujourd'hui, encore en récupération : ${i?.muscles}`)
};

const de_de2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Heute ausgelassen, noch in Erholung: ${i?.muscles}`)
};

const it_it2_quick_workout_avoided = /** @type {(inputs: Quick_Workout_AvoidedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esclusi oggi, ancora in recupero: ${i?.muscles}`)
};

/**
* | output |
* | --- |
* | "Left out today, still recovering: {muscles}" |
*
* @param {Quick_Workout_AvoidedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_avoided = /** @type {((inputs: Quick_Workout_AvoidedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_AvoidedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_avoided(inputs)
	if (locale === "es-419") return es_419_quick_workout_avoided(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_avoided(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_avoided(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_avoided(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_avoided(inputs)
	return en_us2_quick_workout_avoided(inputs)
});
export { quick_workout_avoided as "quick-workout.avoided" }